import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class EotmMetricService {

  constructor(private http: HttpClient, private system: SystemService) {}

  /**
   * Create or Update Metric
   * @param metricData Object containing metric name, selected, and weightage
   */
  saveMetric(metricData: any): Observable<any> {
    return this.http.post(`${this.system.apiURL}/eotm-metrics/create-or-update`, metricData);
  }

  /**
   * Get all metrics from the backend
   */
  getMetrics(): Observable<any> {
    return this.http.get(`${this.system.apiURL}/eotm-metrics`);
  }

}
